<template>
  <div class="login" style="height: 100%">
    <div class="weui-form">
      <div class="weui-form__text-area">
        <h2 class="weui-form__title">{{ $t("reg.resetPwd") }}</h2>
      </div>
      <div class="weui-form__control-area" style="
          max-width: 500px;
          display: block;
          margin-left: auto;
          margin-right: auto;
        ">
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("reg.password") }}</label>
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__bd">
                <input v-model="password" type="password" class="weui-input" />
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{
                  $t("reg.passwordConfirm")
                }}</label>
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__bd">
                <input v-model="password2" type="password" class="weui-input" />
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label" style="width: 3rem">{{
                  $t("email")
                }}</label>
              </div>
              <div class="weui-cell__hd">
                <a class="weui-btn weui-btn_primary" style="width: 12rem" v-on:click="onSendVerifyCode"
                  href="javascript:">{{ $t("send") }}</a>
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__bd" style="width: 6rem">
                <input v-model="email" class="weui-input" />
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">{{ $t("reg.verifyCode") }}</label>
              </div>
            </div>
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__bd" style="width: 5rem">
                <input v-model="verifyCode" class="weui-input" />
              </div>
            </div>
          </div>
        </div>
        <div class="weui-cell weui-cell_active">
          <a class="weui-btn weui-btn_primary" v-on:click="onForgot" href="javascript:">{{ $t("save") }}</a>
        </div>
      </div>

      <div class="weui-form__extra-area">
        <div class="weui-footer">
          <p class="weui-footer__text">Copyright © 2024 openp2p.cn</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import weui from "weui.js"
import * as err from "../error.js"
export default {
  name: "Register",
  data() {
    return {
      username: "",
      password: "",
      password2: "",
      phone: "",
      email: "",
      verifyCode: "",
      emailHolder: this.$t("reg.emailTips"),
    }
  },
  props: {
    msg: String,
  },
  methods: {
    onSendVerifyCode() {
      let _this = this
      // TODO: validate email format
      axios
        .get(
          this.$ServerHost + "api/v2/verificationcode?email=" + this.$data.email
        )
        .then((response) => {
          if (response.status == 200 && response.data.error == 0) {
            weui.alert(_this.$t("sendVerificationCodeOK"), {
              buttons: [
                {
                  label: _this.$t("ok"),
                },
              ],
            })
            // _this.$router.replace('/')
          } else {
            window.debugLog("SendVerifyCode error:", response)
            var errDetail
            if (response.data.error == err.ErrEmailInvalid) {
              errDetail = _this.$t("emailInvalidError")
            }
            weui.alert(
              _this.$t("sendVerificationCodeError") + ":" + errDetail,
              {
                buttons: [
                  {
                    label: _this.$t("ok"),
                  },
                ],
              }
            )
          }
        })
        .catch(function () {
          weui.alert(_this.$t("reg.sendVerificationCodeError"), {
            buttons: [
              {
                label: _this.$t("ok"),
              },
            ],
          })
        })
    },
    onForgot() {
      let _this = this
      window.debugLog("resetpwd")
      if (this.password != this.password2) {
        weui.alert(this.$t("reg.pwdDiff"))
        return
      }
      if (this.password.length < 8) {
        weui.alert(this.$t("reg.tooShort"), {
          buttons: [
            {
              label: this.$t("ok"),
            },
          ],
        })
        return
      }
      axios
        .post(this.$ServerHost + "/api/v2/user/resetpwd", {
          code: this.$data.verifyCode,
          password: this.$data.password,
          email: this.$data.email,
        })
        .then((response) => {
          if (response.status == 200 && response.data.error == 0) {
            weui.alert(_this.$t("reg.resetPwdOK"), {
              buttons: [
                {
                  label: _this.$t("ok"),
                },
              ],
            })
            _this.$router.replace("/")
          } else {
            window.debugLog("resetPwd error:", response)
            var errDetail
            if (response.data.error == err.ErrVerificationCode) {
              errDetail = _this.$t("reg.verificationCodeError")
            }
            if (response.data.error == err.ErrPwdTooShort) {
              errDetail = _this.$t("reg.tooShort")
            }
            weui.alert(_this.$t("reg.resetPwdError") + ":" + errDetail, {
              buttons: [
                {
                  label: _this.$t("ok"),
                },
              ],
            })
          }
        })
        .catch(function () {
          weui.alert(_this.$t("reg.resetPwdError"), {
            buttons: [
              {
                label: _this.$t("ok"),
              },
            ],
          })
        })
    },
  },
}
</script>

<style scoped>
@import "../assets/css/weui.scss";

.weui-label {
  display: block;
  width: 9.5rem;
  word-wrap: break-word;
  word-break: break-all;
}

.weui-input {
  width: 20rem;
}

.weui-cells__group_form .weui-cell {
  padding: 8px 16px;
}
</style>